import React from 'react'

const House = () => (
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 5.5L3 0h16l3 5.5v3.8l-2.6 1.1v8.1H2.6v-8.1L0 9.4V5.4zm4-4L1.6 6v2.4l1.7.7 1.8-.7V5.5h1.6v2.8l1.7.7 1.8-.7V5.5h1.6v2.8l1.8.7 1.7-.7V5.5H17v2.8l1.8.7 1.7-.7V5.9L18 1.6H4zM8.9 17v-2.4h4.2V17H8.9zm5.8-4v4h3.2v-6.6L16 9.6l-2.5 1.1-2.6-1-2.6 1-2.5-1-1.8.7V17h3.2v-4h7.4z" fill="currentColor"/></svg>
)

export default House